import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "reactstrap";

//Import Images
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Language from "Enums/Language";
import AmenitiesService from "services/Admin/AmenitiesService";
// import FileUpload from "pages/Admin/Compound/UploadModal/fileUpload";
import FileUpload from "components/Common/UploadImgCroped/file-upload.component";

const languages = ["en", "ar", "zh", "ru"];

function ModalForm({ modal, toggle, isAdd, editObj, type, setShouldGetData }) {
	const [loading, setLoading] = useState(false);
	const service = new AmenitiesService();
	const [uploadState, setUploadState] = useState(false);

	const [formData, setFormData] = useState({
		en: "",
		ar: "",
		ru: "",
		zh: "",
		media_id: "",
	});

	useEffect(() => {
		if (editObj?.id) {
			service.find(editObj?.id).then((res) => {
				if (res && res.status === SuccessOk) {
					setFormData({
						en: res.data.name?.en || "",
						ar: res.data.name?.ar || "",
						ru: res.data.name?.ru || "",
						zh: res.data.name?.zh || "",
						media_id: res.data.media?.id || "",
						media_id_path: res.data.media?.path || "",
						media: [
							{
								id: res.data.media?.id,
								path: res.data.media?.path,
							},
						],
					});
				}
			});
		}
	}, []);

	const handleFieldChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleValidSubmit = (_, values) => {
		let data = {
			name: {},
		};
		languages.forEach((language) => {
			if (formData[language].length) {
				data.name[language] = formData[language];
			}
		});
		if (!!formData?.media_id) data["media_id"] = formData?.media_id;
		setLoading(true);
		if (isAdd) {
			service.create(data).then((res) => {
				if (res && res.status === SuccessCreated) {
					setShouldGetData(true);
					toast.success("Amenities Added successfully");
					toggle();
				} else {
					setLoading(false);
					toast.error(res);
				}
			});
		} else {
			service.update(editObj.id, data).then((res) => {
				if (res && res.status === SuccessOk) {
					setShouldGetData(true);
					toast.success("Amenities Edited Successfully");
					toggle();
				} else {
					setLoading(false);
					toast.error(res);
				}
			});
		}
	};

	const updatedAttachment = (attachments, type) => {
		const mediaObj = {
			[`${type}`]: attachments[0]?.id,
			[`${type}_path`]: attachments[0]?.path,
		};
		setFormData({ ...formData, ...mediaObj });
	};

	const deleteAttachment = (_, type) => {
		const mediaObj = {
			[type]: null,
			[`${type}_path`]: null,
		};
		setFormData({ ...formData, ...mediaObj });
	};
	return (
		<Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
			<ModalHeader toggle={toggle}>
				{isAdd ? `Add New ${type} ` : `Update ${type}`}
			</ModalHeader>
			<ModalBody>
				<AvForm
					className="form-horizontal"
					onValidSubmit={(e, v) => {
						handleValidSubmit(e, v);
					}}>
					<Row>
						{Language.LIST.map((lan, index) => {
							return (
								<Col md={6} key={index}>
									<AvField
										className="mb-3"
										name={lan.name}
										label={lan.label}
										bsSize="lg"
										value={formData[`${lan.name}`]}
										onChange={(e) => handleFieldChange(e)}
										validate={{
											required: {
												value: lan.name === "en" ? true : false,
												errorMessage: "This Field is required",
											},
											pattern: {
												value:
													lan.name === "en"
														? "/^[A-Za-z ]+$/"
														: lan.name === "ar"
														? "/^[\u0621-\u064A ]+$/"
														: "",
												errorMessage: `${
													lan.name == "en" ? "English" : "Arabic"
												} format is invalid`,
											},
										}}
										placeholder={
											lan.name === "en"
												? "English"
												: lan.name === "ar"
												? "عربي"
												: lan.name === "zh"
												? "Zh"
												: "Ru"
										}
									/>
								</Col>
							);
						})}
					</Row>

					<Row>
						<Col md={12}>
							<FileUpload
								accept=".png,.PNG"
								label="Image"
								attachmentType="media_id"
								setUpload={() => {}}
								ratio={{ x: 1, y: 1 }}
								attachmentData={formData.media}
								updatedAttachment={updatedAttachment}
								deleteAttachment={deleteAttachment}
								setFile={setUploadState}
							/>
						</Col>
					</Row>
					<ModalFooter className="px-0">
						<button
							disabled={loading ? true : false}
							type="submit"
							className="btn btn-success w-100">
							{isAdd ? "Add Amenities" : "Update Amenities"}
						</button>
					</ModalFooter>
				</AvForm>
			</ModalBody>
		</Modal>
	);
}

export default ModalForm;
